<section
  class="forgot-password-section container-fluid sts-section ">


  <app-sts-section-header key="sts-voided-link-header" [errors]="errors">
    Unavailable
  </app-sts-section-header>

  



  <app-sts-lower-bar>
    <a href="/" app-sts-cms-txt key="sts-go-back" class="sts-btn">Go Back</a>
  </app-sts-lower-bar>



</section>
